module.exports = __webpack_public_path__ + "img/img-4.aa65e00d.png";